import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import PostContent from "../components/PostContent";
import { Helmet } from "react-helmet";
import { PageProps } from "gatsby";

const Noticia: React.FC<PageProps> = ({ location, pageContext }) => {
  const { title, date, body, image }: any = pageContext;
  const pathNews = location.href;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Começa a distribuição de Vale Gás em São Luís</title>
      </Helmet>

      <Navbar />
      <PostContent
        title={title}
        body={body}
        date={date}
        pathNews={pathNews}
        image={image}
      />
      <Footer />
    </>
  );
};

export default Noticia;
